/**
 * Created by Claude on 27.01.2026
 *
 * https://arkadiumsdk.z19.web.core.windows.net/docs/features/persistence
 */

const ArkadiumLocalStorage = function () {

};

ArkadiumLocalStorage.prototype.initialize = function (callback) {
    connector.platform.whenConnected(callback);
};

ArkadiumLocalStorage.prototype.getItemAsync = function (key) {
    return ArkadiumSDK.persistence.getLocalStorageItem(key);
};

ArkadiumLocalStorage.prototype.setItemAsync = function (key, value) {
    return ArkadiumSDK.persistence.setLocalStorageItem(key, value);
};
